import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import apple from "@baseImg/footer/Payments/icon-payment-apple.svg";
import bank from "@baseImg/footer/Payments/icon-payment-bank.svg";
import bpay from "@baseImg/footer/Payments/icon-payment-bpay.svg";
import easypay from "@baseImg/footer/Payments/icon-payment-easypay.svg";
import epay from "@baseImg/footer/Payments/icon-payment-epay.svg";
import mastercard from "@baseImg/footer/Payments/icon-payment-mastercard.svg";
import paypal from "@baseImg/footer/Payments/icon-payment-paypal.svg";
import transcard from "@baseImg/footer/Payments/icon-payment-transcard.svg";
import visa from "@baseImg/footer/Payments/icon-payment-visa.svg";

const BG = {
	firstRow: {
		title: '<a href="https://help.superhosting.bg/payment-methods.html" target="_blank" title="Начини на плащане">Начини на плащане:</a>',
		content: [
			{
				name: 'Apple Pay',
				icon: apple,
				iconAlt: 'Apple Pay'
			},
			{
				name: 'ePay',
				icon: epay,
				iconAlt: 'Epay'
			},
			{
				name: 'B-Pay (банкомат)',
				icon: bpay,
				iconAlt: 'Bpay'
			},
			{
				name: 'PayPal',
				icon: paypal,
				iconAlt: 'PayPal}'
			},
			{
				name: 'EasyPay',
				icon: easypay,
				iconAlt: 'EasyPay'
			},
			{
				name: 'Банков превод',
				icon: bank,
				iconAlt: 'Банков превод'
			},
			{
				name: 'Transcard',
				icon: transcard,
				iconAlt: 'Transcard'
			}
		]
	},
	secondRow: {
		title: 'Кредитни карти:',
		content: [
			{
				name: 'Visa',
				icon: visa,
				iconAlt: 'Visa'
			},
			{
				name: 'MasterCard',
				icon: mastercard,
				iconAlt: 'MasterCard'
			}
		]
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	firstRow: {
		title: '<a href="https://help.superhosting.bg/en/payment-methods.html" target="_blank" title="Payment methods">Payment methods:</a>',
		content: [
			{
				name: 'Apple Pay',
				icon: apple,
				iconAlt: 'Apple Pay'
			},
			{
				name: 'ePay',
				icon: epay,
				iconAlt: 'Epay'
			},
			{
				name: 'B-Pay (ATM)',
				icon: bpay,
				iconAlt: 'Bpay'
			},
			{
				name: 'PayPal',
				icon: paypal,
				iconAlt: 'PayPal}'
			},
			{
				name: 'EasyPay',
				icon: easypay,
				iconAlt: 'EasyPay'
			},
			{
				name: 'Bank transfer',
				icon: bank,
				iconAlt: 'Bank transfer'
			},
			{
				name: 'Transcard',
				icon: transcard,
				iconAlt: 'Transcard'
			}
		]
	},
	secondRow: {
		title: 'Credit cards:',
		content: [
			{
				name: 'Visa',
				icon: visa,
				iconAlt: 'Visa'
			},
			{
				name: 'MasterCard',
				icon: mastercard,
				iconAlt: 'MasterCard'
			}
		]
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];